export default {"src":"/_next/static/media/LoadingAnimated.747b070e.svg","height":183,"width":183,"blurWidth":0,"blurHeight":0};